module.exports = __webpack_public_path__ + "static/media/popup_close.d4a4083f.svg";